export default "__VITE_ASSET__BdYxOHh3__"